$(document).ready(function() {
  if ($('#jobOffers').length > 0) {
    var navLink = $('.offer-link');

    navLink.on('click', function(e) {
      e.preventDefault();
      var contentId = $(this).data('tab-to-show');
      var contentToShowParent = $("#"+contentId);
      var contentToShow = contentToShowParent.children('.offer-tab');
      var contentToShowHeight = contentToShow.height();
      if (contentToShowParent.hasClass('active')) {
        contentToShowParent.animate({
          height: 0,
        }, 500, function() {
          $(this).removeClass('active');
        });
      } else {
        contentToShowParent.addClass('transit');
        contentToShowParent.animate({
          height: contentToShowHeight,
        }, 500, function() {
          $(this).addClass('active');
          $(this).removeClass('transit')
        });
        $('.offer-content').not('.transit').removeClass('active');
        $('.offer-content').not('.transit').animate({
          height: 0,
        });
      }
    })
  }
});
